export default __webpack_public_path__ + "static/media/assessment_glide_7_2.cbf743fb.svg";